import { createFaasProcedureConfig } from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';

// https://explorer.aexp.com/functions/ReadCustomerProducts.v1
export default createFaasProcedureConfig(
  'ReadCustomerProducts.v2'
);
